
import { Vue, Options } from "vue-class-component";
import { useStore } from "vuex";
import ApiService from "../services/ApiService";
import StorageService from "@/services/StorageService";
import { wrapper } from "../utils/wrapper";
import { getModulesCount } from "@/utils/modules";
import { docs, version } from "../config";

@Options({
  props: {
    showHelpModal: Boolean
  }
} as any)
export default class HelpModal extends Vue {
  private apiService = new ApiService();
  private storageService = new StorageService();
  globalStore = useStore();
  user: any = null;
  numberOfModules: any = null;
  treatmentSet = true;
  manualsPath: any = null;
  version: any = null;

  async created() {
    this.user = this.storageService.getUser();
    await this.getNumberOfModules();
    this.manualsPath = this.getManualsPath();
    this.version = version;
  }

  getManualsPath() {
    return {
      website: docs.websitePath(this.user.language),
      app: docs.appPath(this.user.language),
      video: docs.videoPath()
    };
  }

  closeModal() {
    this.$emit("clicked", "accepted");
  }

  async getNumberOfModules() {
    const treatment = await wrapper(this.getTreatment());

    if (treatment.error) {
      this.treatmentSet = false;
      return;
    }

    const modulesCount = await wrapper(getModulesCount(treatment.data));

    if (modulesCount.error) {
      this.treatmentSet = false;
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.MODULES.GET.FAILED.TITLE"),
        text: this.$t("ALERTS.MODULES.GET.FAILED.TEXT")
      });
      return;
    }

    if (typeof modulesCount.data === "number") {
      this.treatmentSet = true;
      this.numberOfModules = modulesCount.data;
    } else {
      this.treatmentSet = false;
    }
  }

  async getTreatment() {
    const dataResponse = await wrapper(
      this.apiService.getTreatment(this.user.patientsId)
    );
    if (dataResponse.error) {
      console.error("get modules error ", dataResponse.error);
      throw dataResponse.error;
    }

    if (dataResponse.data) {
      return dataResponse.data;
    }
  }

  async expandCollapsible(event: any) {
    const collapsible = event.target;
    const collapsibleContent = collapsible.nextElementSibling;

    collapsible.classList.toggle("active");
    if (collapsibleContent.style.maxHeight) {
      collapsibleContent.style.maxHeight = null;
    } else {
      collapsibleContent.style.maxHeight =
        collapsibleContent.scrollHeight + "px";
    }
  }
}
